import { useContext, useLayoutEffect, useMemo, useState } from "react";
import CustomizerContext from "../../../../../_helper/Customizer";
import {
    Description,
    ExpenseCategory,
    ExpenseGroup,
    Name,
    CreatedBy,
    ModifiedBy,
    Status,
} from "../../../../../Constant";
import {
    financesExpenseCategoryApi,
    financesExpenseGroupApi,
} from "../../../../../api";
import { createDropdownField } from "../../../../../Data/FormField/PublicData";
import useAxiosPrivate from "../../../../../Hooks/useAxiosPrivate";
import useAuth from "../../../../../Hooks/useAuth";
import { IExpenseGroupResponse } from "../ExpenseGroup.types";
import { formatDateWithTimeZone } from "../../../../../_helper/dateHelper";
import { toast } from "react-toastify";
import { StatusRow } from "../../ReportType/List/ReportTypeList";

export default function useExpenseGroupListController() {
    const axiosPrivate = useAxiosPrivate();
    const { userOrganisationId }: any = useAuth();
    const title = ExpenseGroup;
    const [formFields, setFormFields] = useState<any[]>([
        {
            id: "name",
            name: "name",
            label: Name,
            type: "text",
            value: "",
            required: true,
            colSize: 6,
        },

        {
            id: "description",
            name: "description",
            label: Description,
            type: "textarea",
            value: "",
            required: true,
            colSize: 6,
        },

        {
            id: "is_active",
            name: "is_active",
            label: Status,
            type: "switch",
            value: "1",
            colSize: 6,
        },
    ]);

    //?? DROPDOWNS INITS >
    const expenseCategoryDropDown = createDropdownField(
        axiosPrivate,
        "expense_category_id",
        "expense_category_id",
        ExpenseCategory,
        `${financesExpenseCategoryApi}?skip=${0}&limit=${10}&with_trashed=${false}&organisation_id=${userOrganisationId}`,
        "",
        6
    );
    expenseCategoryDropDown.onChange = async (id, updatedFields) => {
        const updatedFormFields = updatedFields.map((field: any) => {
            if (field.id === "expense_category_id") {
                return { ...field, value: id };
            }
            return field;
        });
        setFormFields([...updatedFormFields]);
    };

    useLayoutEffect(() => {
        //?? Updates all fields once component is mounted
        (async function () {
            const updatedFields = [expenseCategoryDropDown, ...formFields];
            await expenseCategoryDropDown.fetchOptions();
            setFormFields(updatedFields);
        })();
    }, []);

    const tableColumns = [
        {
            name: Name,
            selector: (row: (typeof data)[0]) => `${row.name}`,
            sortable: true,
            center: false,
        },

        {
            name: Description,
            selector: (row: (typeof data)[0]) => `${row.description}`,
            sortable: false,
            center: false,
        },
        {
            name: Status,
            selector: (row: (typeof data)[0]) => `${row.is_active}`,
            sortable: true,
            center: true,
            cell: (row: (typeof data)[0]) => StatusRow(row),
        },

        {
            name: ExpenseCategory,
            selector: (row: (typeof data)[0]) => `${row.expense_category.name}`,
            sortable: true,
            center: false,
        },

        {
            name: CreatedBy,
            selector: (row: (typeof data)[0]) =>
                `${formatDateWithTimeZone(row.created_at)}`,
            sortable: false,
            center: false,
        },

        {
            name: ModifiedBy,
            selector: (row: (typeof data)[0]) =>
                `${formatDateWithTimeZone(row.updated_at)}`,
            sortable: false,
            center: false,
        },
    ];

    function fetchData() {
        setLoading(true);
        axiosPrivate
            .get(
                `${financesExpenseGroupApi}?skip=${0}&limit=${10}&with_trashed=${false}&organisation_id=${userOrganisationId}`
            )
            .then((res) => {
                const response: IExpenseGroupResponse[] = res.data;
                setData(response);
                setLoading(false);
            })
            .catch((err) => {
                if (err.response && err.response.status === 404) {
                  toast.error(err.response.data.detail);
                } else {
                  toast.error('Something Went Wrong');
                }
              })
            .finally(() => {
                setLoading(false);
            });
    }

    useLayoutEffect(() => {
        fetchData();
    }, []);

    const handleEdit = (row: (typeof data)[0] | any) => {
        setViewModalOpen(true);
        setEditMode(true);
        // row.expense_category = row?.expense_category.id;
        expenseCategoryDropDown.onChange(row?.expense_category.id, formFields);
        setSelectedRowData(row);
    };

    const { layoutURL } = useContext(CustomizerContext);
    const newBtn = `${process.env.PUBLIC_URL}/finance/settings/expense-group/create/${layoutURL}`;
    const [loading, setLoading] = useState(true);
    const [data, setData] = useState<IExpenseGroupResponse[]>([]);
    const [viewModalOpen, setViewModalOpen] = useState(false);
    const [selectedRowData, setSelectedRowData] = useState<
        (typeof data)[0] | null
    >(null);
    const [editMode, setEditMode] = useState(false);

    const handleView = (row: (typeof data)[0]) => {
        setViewModalOpen(true);
        setEditMode(false);
        setSelectedRowData(row);
    };

    const handleEditRec = async (
        id: number | string,
        editRecord: (typeof data)[0]
    ) => {
        console.log(id, editRecord);
        axiosPrivate
            .put(`${financesExpenseGroupApi}/${id}`, {
                ...editRecord,
                organisation_id: userOrganisationId,
            })
            .then((_res) => {
                const updatedData = data.map((row) =>
                    row.id === selectedRowData!.id ? { ...row, ..._res.data } : row
                );
                setData(updatedData);
                toast.success(`${_res.data.name} Editted Successfully.`)
                //fetchData();
            })
            .catch((err) => {
              if (err.response && err.response.status === 422) {
                toast.error('Validation Errors');
              } else if (err.response && err.response.status === 400) {
                toast.error(err.response.data.detail);
              } else {
                toast.error('Something Went Wrong');
              }
              throw err;
              //toast.error(err.response.message || "Whoops! Something went wrong");
            });
    };

    const memoizedHandleEdit = useMemo(
        () => handleEditRec,
        [data, selectedRowData]
    );

    return {
        data,
        tableColumns,
        viewModalOpen,
        selectedRowData,
        editMode,
        newBtn,
        title,
        formFields,
        setViewModalOpen,
        handleView,
        handleEdit,
        loading,
        memoizedHandleEdit,
    };
}
